import React, { useEffect, useState } from 'react';
import { Car } from '@upstart/harmony/lib/legos/carTypes';
import { JsonLink } from './JsonLink';
import './LendingSupport.scss';
import CarService from '../../services/CarService';

interface Props {
  carId?: string | null;
  onClick: (car?: Car | null) => void;
  onError: (message: string) => void;
}

export const LendingSupportCar: React.FC<Props> = ({
  carId,
  onClick,
  onError,
}) => {
  const [car, setCar] = useState<Car | null>();

  useEffect(() => {
    setCar(undefined);
    if (!carId) {
      return;
    }
    CarService.getCar(carId)
      .then((carObj) => {
        setCar(carObj);
      })
      .catch(() => {
        onError('Unable to fetch car');
      });
  }, [carId]);

  const getCarName = (carObj?: Car | null) => {
    if (!carObj) {
      return undefined;
    }
    return `${carObj.year} ${carObj.make} ${carObj.model} (${carObj.id})`;
  };

  return (
    <>
      <div>Current car:</div>
      <JsonLink
        data={car}
        dataTestId={`car-link-${car?.id}`}
        onClick={() => onClick(car)}
        text={getCarName(car)}
      />
    </>
  );
};
